/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_Lo as Lo,
  rec_Modal as Modal,
  rec_React as React,
  rec_Ro as Ro,
  rec_SelectorFecha as SelectorFecha,
  rec_api as api,
  rec_obtenerUsuario as obtenerUsuario,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function NuevaMeta({ proyectoId: e, onClose: t, onGuardado: n }) {
  let [r, i] = (0, React.useState)(``),
    [a, o] = (0, React.useState)(``),
    [s, c] = (0, React.useState)(``),
    [l, u] = (0, React.useState)(``),
    [f, p] = (0, React.useState)(!1);
  async function m(i) {
    if ((i.preventDefault(), !f)) {
      p(!0);
      try {
        (await api(`/metas`, {
          method: `POST`,
          body: JSON.stringify({
            proyectoId: e,
            titulo: r,
            descripcion: a,
            fechaObjetivo: s || null,
            actorNombre: obtenerUsuario()?.nombre,
          }),
        }),
          n(),
          t());
      } catch (e) {
        (u(e.message), p(!1));
      }
    }
  }
  return (
    <Modal
      titulo={`Nueva meta`}
      onClose={t}
      children={
        <form
          onSubmit={m}
          className={`flex flex-col gap-3`}
          children={[
            <input
              className={Lo}
              placeholder={`Titulo de la meta`}
              value={r}
              onChange={(e) => i(e.target.value)}
              required={!0}
              autoFocus={!0}
            />,
            <textarea
              className={`${Lo} min-h-20`}
              placeholder={`Descripción`}
              value={a}
              onChange={(e) => o(e.target.value)}
            />,
            <label
              className={`text-xs text-(--text)`}
              children={[
                `Fecha objetivo`,
                <SelectorFecha value={s} onChange={c} />,
              ]}
            />,
            l && <p className={`text-sm text-(--error)`} children={l} />,
            <div
              className={`flex justify-end gap-2`}
              children={[
                <button
                  type={`button`}
                  onClick={t}
                  className={zo}
                  children={`Cancelar`}
                />,
                <button
                  type={`submit`}
                  disabled={f}
                  className={Ro}
                  children={`Crear`}
                />,
              ]}
            />,
          ]}
        />
      }
    />
  );
}
